"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogoutType;
(function (LogoutType) {
    /**
     * Log the user out of all sessions.
     */
    LogoutType["ALL"] = "all";
    /**
     * Log the user out of all sessions except the current session.
     */
    LogoutType["ALL_BUT_CURRENT"] = "all_but_current";
    /**
     * Log the user out of their current session (default).
     */
    LogoutType["CURRENT"] = "current";
    /**
     * Only log the user out if the current token is invalid or the token can't be refreshed.
     */
    LogoutType["VERIFY_TOKEN"] = "verify_token";
})(LogoutType || (LogoutType = {}));
exports.default = LogoutType;
//# sourceMappingURL=enums.js.map